module.exports = __webpack_public_path__ + "img/kuroda.4e439b84.png";